import type { JSX } from 'solid-js';
import { useFleetLive } from '../lib/fleet-live-read';
import type { ToastTone } from '../lib/toast';
import { FleetLiveSection } from './FleetLiveSection';

// Fleet Live (#6778, #6779) — CONTAINER: the read (`useFleetLive`: `GET /v1/fleet/live`, then
// the `fleet_live` topic over the shell's one account stream) handed to the presenter, with
// what the Fleet page owns: whether this person may write the Merge Gate (`canWrite`, the
// page's `roleSettled && canAdminWrite`), whether one of its dialogs is open (the floating
// Core leaves while one is), and its toast.

export function FleetLive(props: {
  readonly token: string | null;
  readonly canWrite: boolean;
  readonly dialogOpen: () => boolean;
  readonly notify: (message: string, tone?: ToastTone) => void;
}): JSX.Element {
  const read = useFleetLive(props.token);
  return (
    <FleetLiveSection
      read={read}
      token={props.token}
      canWrite={props.canWrite}
      dialogOpen={props.dialogOpen}
      notify={props.notify}
    />
  );
}
